import { defineComponent, onMounted, PropType } from "vue";
import { gsap, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

interface LinkItem {
  title: string;
  id: string;
  label?: string;
}
export default defineComponent({
  props: {
    items: { type: Array as PropType<LinkItem[]>, required: true },
  },
  setup() {
    const scrollToSection = (e: PointerEvent): void => {
      e.preventDefault();

      const target = e.target as HTMLElement;
      const href = target.getAttribute("href");
      const id = href!.slice(href!.indexOf("#"));

      gsap.to(window, {
        duration: 1,
        ease: "power2.inOut",
        scrollTo: {
          y: `${id}`,
          offsetY: 25,
        },
      });
    };

    return { scrollToSection };
  },
});
